// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ltugnhpocjzhouvvciek.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx0dWduaHBvY2p6aG91dnZjaWVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg5OTg5NDIsImV4cCI6MjA3NDU3NDk0Mn0.NcMTE1oJ164GqyRIZ52wz4CN6M9mPSLj_AX1mDRi22c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});